// extracted by mini-css-extract-plugin
module.exports = {"qrContainer":"qr_qrContainer__2QlRC"};